module.exports = __webpack_public_path__ + "static/media/logo_bndmet_vertical_white.f4282044.png";